import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

window.React = React;
window.ReactDOM = ReactDOM;

import './components/Shell.jsx';
import './components/Hero.jsx';
import './components/HowItWorks.jsx';
import './components/Pillars.jsx';
import './components/Founders.jsx';
import './components/Testimonial.jsx';
import './components/Waitlist.jsx';
import './components/FooterFAQ.jsx';

const { useState, useEffect } = React;
const { Nav, Marquee, DayNightToggle, useClickSpark, useCursorGlow, useReveal } = window;
const { Hero, HowItWorks, Pillars, Founders, Waitlist, Footer, FAQ, DemoModal } = window;
const ACCENT = '#FF5405';

function App() {
  const [dark, setDark] = useState(false);

  useClickSpark(true);
  useCursorGlow(true);
  useReveal();

  useEffect(() => {
    document.documentElement.style.setProperty('--accent', ACCENT);
    document.documentElement.style.setProperty('--krew-spark', ACCENT);
    document.documentElement.style.setProperty('--accent-soft', ACCENT + '1f');
    document.documentElement.style.setProperty('--shadow-spark', `3px 3px 0 ${ACCENT}`);
    document.body.classList.add('paper-grain');
    document.body.classList.toggle('is-dark', dark);

    if (dark) {
      document.documentElement.style.setProperty('--bg-page', '#1C1A18');
      document.documentElement.style.setProperty('--bg-surface', '#24211E');
      document.documentElement.style.setProperty('--bg-raised', '#2C2925');
      document.documentElement.style.setProperty('--fg-1', '#EDE4D3');
      document.documentElement.style.setProperty('--fg-2', 'rgba(237,228,211,0.85)');
      document.documentElement.style.setProperty('--fg-3', 'rgba(237,228,211,0.6)');
      document.documentElement.style.setProperty('--fg-4', 'rgba(237,228,211,0.45)');
      document.documentElement.style.setProperty('--border-hair', 'rgba(237,228,211,0.1)');
      document.documentElement.style.setProperty('--border-soft', 'rgba(237,228,211,0.2)');
      document.documentElement.style.setProperty('--border-strong', 'rgba(237,228,211,0.4)');
      document.documentElement.style.setProperty('--krew-ink', '#0E0D0C');
      document.documentElement.style.setProperty('--krew-grain-pale', '#2C2925');
      document.documentElement.style.setProperty('--krew-grain-warm', '#24211E');
    } else {
      document.documentElement.style.removeProperty('--bg-page');
      document.documentElement.style.removeProperty('--bg-surface');
      document.documentElement.style.removeProperty('--bg-raised');
      document.documentElement.style.removeProperty('--fg-1');
      document.documentElement.style.removeProperty('--fg-2');
      document.documentElement.style.removeProperty('--fg-3');
      document.documentElement.style.removeProperty('--fg-4');
      document.documentElement.style.removeProperty('--border-hair');
      document.documentElement.style.removeProperty('--border-soft');
      document.documentElement.style.removeProperty('--border-strong');
      document.documentElement.style.removeProperty('--krew-ink');
      document.documentElement.style.removeProperty('--krew-grain-pale');
      document.documentElement.style.removeProperty('--krew-grain-warm');
    }
  }, [dark]);

  return (
    <div data-screen-label="Krew landing">
      <Nav />
      <main id="main-content">
        <Hero />
        <HowItWorks />
        <Pillars />
        <Marquee />
        <Founders />
        <Waitlist />
        <FAQ />
      </main>
      <Footer />
      <DemoModal />
      <DayNightToggle dark={dark} onToggle={() => setDark(!dark)} />
    </div>
  );
}

createRoot(document.getElementById('root')).render(<App />);
